import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { CompanyService } from 'src/app/core/services/company.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UibModalService } from 'src/app/core/services/uibModalService';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

declare var $: any;

const SHELL_BODY_CLASS = 'mission-control-shell';

@Component({
  selector: 'app-mission-control-page',
  templateUrl: './mission-control-page.component.html',
  styleUrls: ['./mission-control-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MissionControlPageComponent implements OnInit, AfterViewInit, OnDestroy {

  MESSAGECONSTANTS = MESSAGECONSTANTS;
  isInHost: boolean;

  constructor(
    private authService: AuthService,
    private $state: StateService,
    private renderer: Renderer2,
    private storageService: StorageService,
    public companyService: CompanyService,
    private userRoleService: UserRoleService,
    private uibModalService: UibModalService,
    private utilityService: UtilityService
  ) { }

  get userDetails(): any {
    return this.authService.userDetails;
  }

  get isNavDisabled(): boolean {
    const company = this.userDetails.company;
    return company.companyId === null || company.companyState === 'Draft' || company.companyState === 'Hold';
  }

  get isSuperUserOrFourDotFiveAdmin(): boolean {
    const role = this.userDetails.roleScreenRef.role;
    return this.isSuperUser(role) || this.isFourDotFiveAdmin(role);
  }

  ngOnInit() {
    if (this.userDetails === undefined || this.userDetails === null) {
      this.$state.go('login', null, { reload: true });
      return;
    }
    this.renderer.addClass(document.body, SHELL_BODY_CLASS);

    this.authService.setIsSwitchClicked(false);
    this.isInHost = this.utilityService.isInHost();

    if (this.userDetails.roleScreenRef.role.name === 'CorporateAdmin') {
      this.companyService.selectedCompanyId = this.userDetails.company.companyId;
    }
    if (this.companyService.newlyCreatedCompanyId !== undefined) {
      this.companyService.selectedCompanyId = this.companyService.newlyCreatedCompanyId;
    }
    this.showAllCompaniesIfNeeded();
  }

  ngAfterViewInit() {
    if ($(document).width() < 991) {
      $('#nav-col').addClass('close-sidenav');
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, SHELL_BODY_CLASS);
  }

  /**
   * The popup shows only outside the create-company flow (companyId set) or right
   * after a company deletion, and only while no company has been picked yet.
   */
  private showAllCompaniesIfNeeded() {
    if (this.userDetails.company.companyId != null || this.companyService.companyDeletedShowPopup) {
      this.userDetails.shouldPopupBeDisplayed = true;
      if (!this.userDetails.company.companySelected && this.storageService.get('companyDetails') === null
        && this.isSuperUserOrFourDotFiveAdmin) {
        setTimeout(() => this.uibModalService.showAllCompanies(), 1000);
      }
    }
  }

  hasAccess(screenId: string): boolean {
    const screens = this.userDetails && this.userDetails.roleScreenRef && this.userDetails.roleScreenRef.screen;
    return !!screens && screens.some(screen => screen.id === screenId);
  }

  isSuperUser(role): boolean {
    return this.userRoleService.isSuperUser(role);
  }

  isFourDotFiveAdmin(role): boolean {
    return this.userRoleService.isFourDotFiveAdmin(role);
  }

  isVendor(): boolean {
    return this.companyService.isCompanyVendor();
  }

  isStaffingCompany(): boolean {
    return this.companyService.isStaffingCompany();
  }

  isCorporateCompany(): boolean {
    return this.companyService.isCorporateCompany();
  }

  isRecruiterManager(role): boolean {
    return this.userRoleService.isRecruitingManager(role);
  }

  isLoggedInUserCompanyAdmin(): boolean {
    return this.userRoleService.isLoggedInUserCompanyAdmin();
  }

  isWorkflowScreenActive(): boolean {
    return this.$state.current.url === '/candidateJobMatchesWorkflow';
  }

  isUploadReqScreenActive(): boolean {
    return this.$state.current.url === '/uploadreq';
  }
}
